import { useState } from "react"

export default function PaymentPending() {
    return <>
        <div className="px-[20px] lg:px-[80px] pt-28">
            در حال پردازش
        </div>
    </>
}